"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewQuestion = exports.useCurrentQuestion = void 0;
var _react = require("react");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _useCurrentAnswers = require("./useCurrentAnswers");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
var _services = require("../../services");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
const getQuestionText = () => {
  var _currentQuestion$icon, _currentQuestion$topT, _answers$numberOfPlan;
  const currentQuestion = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestion);
  const defaultPlanPrice = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectLowestPlanPrice);
  if (!currentQuestion) return {};
  const {
    answers
  } = (0, _useCurrentAnswers.useCurrentAnswers)();
  const additionalPlanPrice = _services.locale.formatPrice(defaultPlanPrice);
  const icons = (_currentQuestion$icon = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.icons) !== null && _currentQuestion$icon !== void 0 ? _currentQuestion$icon : {};
  let subtitleText = currentQuestion.subtitle;
  const topTitleText = additionalPlanPrice ? (_currentQuestion$topT = currentQuestion.topTitle) === null || _currentQuestion$topT === void 0 ? void 0 : _currentQuestion$topT.replace('{{value}}', `${additionalPlanPrice}`) : currentQuestion.topTitle;
  const planNumber = answers === null || answers === void 0 ? void 0 : (_answers$numberOfPlan = answers.numberOfPlan) === null || _answers$numberOfPlan === void 0 ? void 0 : _answers$numberOfPlan[0];
  if (typeof subtitleText === 'object') {
    subtitleText = planNumber === 1 ? subtitleText.single.replace('{{value}}', `${planNumber}`) : subtitleText.multi.replace('{{value}}', `${planNumber}`);
  }
  return {
    title: currentQuestion.title,
    subtitle: subtitleText,
    topTitle: topTitleText,
    icons: icons
  };
};
const useCurrentQuestion = () => {
  const question = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestion);
  const questionIndex = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestionIndex);
  const selections = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentSelections);
  const {
    title,
    subtitle,
    topTitle,
    icons
  } = getQuestionText();
  return {
    question,
    questionIndex,
    selections,
    title,
    subtitle,
    topTitle,
    icons
  };
};
exports.useCurrentQuestion = useCurrentQuestion;
const useViewQuestion = questionIndex => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  (0, _react.useEffect)(() => {
    dispatch((0, _questionnaireActions.setViewQuestion)(questionIndex));
  }, [questionIndex]);
};
exports.useViewQuestion = useViewQuestion;